import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Select, Button, Form, message, Spin } from "antd";
import _ from "lodash";
import {
  getretailers,
  getdistributers,
  getmaster,
  getibomarketlistnew,
  createoffice,
  us_states_lifeline,
  office_manager_name,
} from "../../../store/actions/documentActions";

const { Option } = Select;

class AddOffice extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    // state
    this.state = {
      distributor: [],
      master: [],
      retailer: [],
      market: [],
      office: [],
      office_manager: [],
      office_supervisor: [],
      spinloader: false,
      marketrole: false,
      retailerrole: false,
      shortstate: [],
    };
  }

  componentWillMount() {
    this.props.us_states_lifeline().then((res) => {
      console.log(res);
      this.setState({
        shortstate: res.data,
      });
    });

    const Retailer = this.props.user.role_id.filter((word) => word === 12);
    const marketer = this.props.user.role_id.filter(
      (word) => word === 5 || word === 4 || word === 8
    );

    if (marketer.length !== 0) {
      this.setState({
        marketrole: true,
      });
      this.props
        .office_manager_name(0)
        .then((res) => {
          console.log(res);
          this.setState({
            office_manager: res.data.manager_info,
            office_supervisor: res.data.manager_info,
            spinloader: false,
          });
        })
        .catch((err) => {
          this.setState({
            office_manager: [],
            office_supervisor: [],
            spinloader: false,
          });
        });
    }
    if (Retailer.length !== 0) {
      this.setState({
        retailerrole: true,
      });
    }
    this.props.getibomarketlistnew(this.props.user.user_id).then((res) => {
      this.setState({
        market: res.data,
        spinloader: false,
      });
    });
  }

  handleSubmit = (values) => {
    this.setState({
      loading: true,
    });

    this.props
      .createoffice(values)
      .then((res) => {
        console.log(res);
        message.success("Office created successfully");
        this.formRef.current.resetFields();
        this.setState({
          loading: false,
        });
        this.props.history.push("/offices");
      })
      .catch((err) => {
        console.log(err);
        message.error(err);
        this.setState({
          loading: false,
        });
      });
  };
  renderMaster() {
    return _.map(this.state.master, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderDistributor() {
    return _.map(this.state.distributor, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderRetailer() {
    return _.map(this.state.retailer, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderMarketer() {
    return _.map(this.state.market, (master, index) => {
      return (
        <Option value={master.id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderoffice_manager() {
    return _.map(this.state.office_manager, (master, index) => {
      return (
        <Option value={master.user_id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderoffice_supervisor() {
    return _.map(this.state.office_supervisor, (master, index) => {
      return (
        <Option value={master.user_id} key={index}>
          {master.name}
        </Option>
      );
    });
  }
  renderstateshort() {
    return _.map(this.state.shortstate, (master, index) => {
      return (
        <Option value={master.short_name} key={index}>
          {master.name}
        </Option>
      );
    });
  }

  handleretailer = (e) => {
    console.log(e);
    this.setState({
      spinloader: true,
    });
    this.formRef.current.setFieldsValue({
      manager_id: [],
      supervisor_id: [],
    });
    this.props
      .office_manager_name(e)
      .then((res) => {
        console.log(res);
        this.setState({
          office_manager: res.data.manager_info,
          office_supervisor: res.data.manager_info,
          spinloader: false,
        });
      })
      .catch((err) => {
        this.setState({
          office_manager: [],
          office_supervisor: [],
          spinloader: false,
        });
      });
  };

  render() {
    const { loading, spinloader } = this.state;

    return (
      <>
        <Spin spinning={spinloader}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">
                    <strong>Add Office</strong>
                  </h4>
                  <Link to="/offices" className="float-right">
                    <Button type="default">Back</Button>
                  </Link>
                </div>
                <div className="card-body">
                  <Form
                    name="basic"
                    labelCol={{
                      span: 24,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    onFinish={this.handleSubmit}
                    onFinishFailed={this.onFinishFailed}
                    ref={this.formRef}
                    className="addbookform row"
                  >
                    {this.state.retailerrole === true ? (
                      <Form.Item
                        label="IBO Name"
                        className="col-md-4 col-sm-6 col-xs-12"
                        name="ibo_marketer_id"
                        rules={[
                          {
                            required: true,
                            message: "Please select",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          style={{ width: "100%" }}
                          placeholder="Select IBO Name"
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          onChange={(e) => this.handleretailer(e)}
                        >
                          {this.renderMarketer()}
                        </Select>
                      </Form.Item>
                    ) : null}
                    <Form.Item
                      label="State"
                      className="col-md-4 col-sm-6 col-xs-12"
                      name="state_short_name"
                      rules={[
                        {
                          required: true,
                          message: "Please select option",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Select state"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        // onChange={(e) => this.handleretailer(e)}
                      >
                        {this.renderstateshort()}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Office Manager"
                      className="col-md-4 col-sm-6 col-xs-12"
                      name="manager_id"
                      rules={[
                        {
                          required: false,
                          message: "Please Select Office Manager",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Select Office Manager"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }

                        // onChange={(z) => this.setState({ hubs: _.filter(this.state.allhubs, ["Zone", z]) })}
                      >
                        {this.renderoffice_manager()}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Office Add-on Manager"
                      className="col-md-4 col-sm-6 col-xs-12"
                      name="supervisor_id"
                      rules={[
                        {
                          required: false,
                          message: "Please Select Office Add-on Manager",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        mode="multiple"
                        style={{ width: "100%" }}
                        placeholder="Select Office Add-on Manager"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(z) => console.log(z)}
                      >
                        {this.renderoffice_supervisor()}
                      </Select>
                    </Form.Item>
                    <br />
                    <br />
                    <div className="col-md-12 col-sm-12 col-xs-12 padd15">
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                        loading={loading}
                      >
                        Create Office
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { user: state.auth.auth, data: state.data };
}
export default connect(mapStateToProps, {
  getretailers,
  getdistributers,
  getmaster,
  getibomarketlistnew,
  createoffice,
  office_manager_name,
  us_states_lifeline,
})(AddOffice);
